
import styled from 'styled-components';

import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import IncreaseEngagementIntro from '../components/IncreaseEngagement/IncreaseEngagementIntro';
import IncreaseEngagementIntroData from '../components/IncreaseEngagement/IncreaseEngagementIntroData';
import IncreaseEngagementBanner from '../components/IncreaseEngagement/IncreaseEngagementBanner';
import IncreaseEngagementIdeals from '../components/IncreaseEngagement/IncreaseEngagementIdeals';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg"
import { Helmet } from 'react-helmet-async';

const IncreaseEngagement = () => {


    return (
        <>
            < Helmet>
                <title>Boost User Engagement & Retention | Grovs App Growth Platform</title>
                <meta
                    name="description"
                    content="Grovs helps marketers and product teams create seamless user journeys with smart deep linking, automated messaging, and clear engagement insights to grow app retention and LTV."
                />
                <meta
                    name="keywords"
                    content="user engagement, app retention, deep linking, personalized messaging, user journeys, app growth, user behavior insights, Grovs"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Boost User Engagement & Retention with Grovs"
                />
                <meta
                    property="og:description"
                    content="Create meaningful user experiences with Grovs' smart deep linking and targeted messaging to increase retention, referral conversions, and daily active users."
                />
                <meta property="og:url" content="https://www.grovs.io/increase-engagement" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/engagement-social.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Boost User Engagement & Retention | Grovs"
                />
                <meta
                    name="twitter:description"
                    content="Automate targeted messaging and deliver seamless user journeys with Grovs to grow app engagement and retention."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/engagement-social.jpg"
                />
            </Helmet >
            <Container>
                <IncreaseEngagementIntro />
                <IncreaseEngagementIntroData />
                <IncreaseEngagementBanner />
                <IncreaseEngagementIdeals />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.analyseBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Start Increasing User Engagement Today"}
                    subtitle={"Join successful brands already boosting engagement with Grovs. Deliver better user experiences, improve retention, and clearly measure your impact."}
                />
                <TrackingComponent />
            </Container>

        </>
    )
}

export default IncreaseEngagement
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;